import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IBusiness } from '../types/business.type';
import { BusinessUserApi } from '../api/businessUser.api';
import { useAppDispatch, useAppSelector } from './store';

const slice = createSlice({
  name: 'business',
  initialState: {} as IBusiness,
  reducers: {
    set(state, action: PayloadAction<IBusiness>) {
      return action.payload;
    }
  }
});

export const businessReducer = slice.reducer;

export function useBusiness() {

  const dispatch = useAppDispatch();
  const business = useAppSelector(state => state.business);

  return {
    business,
    get() {
      return useAppSelector(state => state.business);
    },
    set(business: IBusiness) {
      dispatch(slice.actions.set(business));
    },
    async fetch() {
      try {
        const business = await BusinessUserApi.getBusiness();
        this.set(business);
      } catch (err) {
        console.error(err);
      }
    }
  };
}
